import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {SettingsService} from "../../core";

@Component({
    selector: 'card',
    standalone: true,
    imports: [
        NgOptimizedImage
    ],
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss'
})
export class CardComponent {
    @Input() title: string = '';
    @Input() icon: string = '';

    constructor(private settings: SettingsService) {
    }

    goToMenu() {
        this.settings.showCard = false;
        this.settings.showMobileMenu = true;
    }
}
